import { render } from "./textwithbulletsTemplate.vue?vue&type=template&id=214ea570&scoped=true&ts=true"
import script from "./textwithbulletsTemplate.vue?vue&type=script&lang=ts"
export * from "./textwithbulletsTemplate.vue?vue&type=script&lang=ts"

import "./textwithbulletsTemplate.vue?vue&type=style&index=0&id=214ea570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214ea570"]])

export default __exports__